'use strict';

/*global window, global*/

var root = typeof window !== 'undefined' ?
    window : typeof global !== 'undefined' ?
    global : {};

module.exports = Individual;

function Individual(key, value) {
    if (key in root) {
        return root[key];
    }

    root[key] = value;

    return value;
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/virtual-dom/~/ev-store/~/individual/index.js
 ** module id = 404
 ** module chunks = 0
 **/